import { NativeModules } from 'react-native';

type HdfcPaymentGatewayType = {
  multiply(a: number, b: number): Promise<number>;
  startPayment(map: {}): Promise<number>;
};

const { HdfcPaymentGateway } = NativeModules;

export default HdfcPaymentGateway as HdfcPaymentGatewayType;
